export default "/images/vendor/flag-icon-css/flags/4x3/md.svg?b51b6be960f624fb9814787ce266958a";